import React from "react";
import "./CalendarView.css";
import { Box, Tabs, Tab } from "@mui/material";
import TasksTabPanel from "../../Components/TasksTabPanel/TasksTabPanel";
import Grid from '@mui/material/Grid2';
import "react-big-calendar/lib/css/react-big-calendar.css";
import EventCalendar from "../../Components/EventCalendar/EventCalendar";
import { GlobalContext } from "../../Context/GlobalContext";

/**
 * A container component for the calendar view. <br>
 * This component is part of the layout and is responsible for rendering the `EventCalendar` component
 * alongside a tabbed interface for managing tasks (`TasksTabPanel`). It interacts with the `GlobalContext`
 * to manage the current tab state.
 *
 * @component
 * @example
 * import CalendarView from '../Layout/CalendarView/CalendarView';
 * <CalendarView />
 * @returns {React.Component} - The `CalendarView` component.
 */
function CalendarView() {
  const ref = React.useRef(null);  
  const { setCurrentTab, currentTab } = React.useContext(GlobalContext);

  /**
   * Generates accessibility properties for the tabs.
   * @param {number} index - The index of the tab.
   * @returns {Object} - An object containing `id` and `aria-controls` attributes for the tab.
   */
  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  /**
   * Handles tab change events.
   * @param {Object} event - The event object.
   * @param {number} newValue - The index of the newly selected tab.
   */
  const handleChange = (event, newValue) => {
    setCurrentTab(newValue);
  };

  /**
   * CSS styles for the container element.
   * @type {Object}
   * @property {string} maxHeight - The maximum height of the container.
   * @property {string} bgcolor - The background color of the container.
   * @property {number} flexGrow - The flex-grow value for the container.
   */
   const ContainerStyle = {
    maxHeight: "calc(100vh - 110px)",
    bgcolor: "white",
    flexGrow: 1
  };

  return (
    <div ref={ref} className="container_body" style={ContainerStyle}>
      <Grid container spacing={2}>
        <Grid size={{ md: 7, lg: 9 }} sx={{}}>
        <EventCalendar/>
        </Grid>
        <Grid size={{ md: 5, lg: 3 }}>
          <Box sx={{
            height: "86vh",
            border: "solid 1px #cfcfcf",
            borderRadius: "30px",
            boxShadow: "3px 11px 7px -6px rgba(161, 156, 161, 1)"
          }}>
          <Tabs 
            value={currentTab} 
            onChange={handleChange} 
            aria-label="tasks panel"
            textColor="inherit"
            TabIndicatorProps={{style: {background:'grey'}}}
            >
              <Tab label="my tasks" sx={{width: "50%"}} {...a11yProps(0)} />
              <Tab label="all tasks" sx={{width: "50%"}} {...a11yProps(1)} />
          </Tabs>
              <TasksTabPanel tabType="myTasks" value={currentTab} index={0}/>
              <TasksTabPanel tabType="allTasks" value={currentTab} index={1}/>
          </Box>
        </Grid>
      </Grid>
    </div>
  );
}

export default CalendarView;
